import { z } from 'zod';

export const evaluationSchema = z.object({
  answers: z.array(
    z.object({
      questionId: z.string(),
      answer: z.string(),
    })
  ),
});

export const defaultValues: Array<{ questionId: string; answer?: string }> = [];
